// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OvTgW","top":"styles_top__2xbWU"};